export const colors = {
  background: '#000000',
  surface: '#2c3153',
  onSurface: 'rgba(82, 76, 174, 0.4)',
  onSurface100: '#2f2f3d',
  onSurface200: '#2e383f',
  onSurface400: '#9fafb9',
  onSurface500: '#d1dee6',
  onSurface600: '#f9f9f9',
  muted: 'rgba(182, 185, 255, 0.8)',
  muted40: 'rgba(182, 185, 255, 0.4)',
  muted10: 'rgba(182, 185, 255, 0.1)',
  text: '#ffffff',
  gray: '#7e7e88',
  // primary is currently same as link
  primary: 'rgba(182, 142, 255, 1)',
  secondary: '#231536',
  success: '#1dd9ba',
  success200: '#e8fcee',
  successGraph: '#33a386',
  error: '#ff6d6d',
  error200: '#f8e7ec',
  errorGraph: '#b44451',
  warning: '#ff832b',
  warning200: '#fcede8',
  warningGraph: '#c57a3a',
  notice: '#e0f1f9',
  link: 'rgba(182, 142, 255, 1)',
  linkHover: 'rgba(255, 255, 255, 0.8)',
  bgGradientStart: '#2a197d',
  bgGradientMiddle: '#4331e9',
  bgGradientEnd: '#6a6cfb',
  transparent: 'transparent',
  border: 'rgba(255, 255, 255, 0.4)',
  border15: 'rgba(255, 255, 255, 0.15)',
  border10: 'rgba(255, 255, 255, 0.1)',
  btnGradientDark: '#29265e',
  btnGradientLight: '#35337c',
  btnGradientDarkHover: '#26225b',
  btnGradientLightHover: '#3a2f77',
  neutral: 'rgba(255, 255, 255, 0.15)',
  tooltip: '#1c1828',
  white: 'rgba(255, 255, 255)',
  white25: 'rgba(255, 255, 255, 0.25)',
  white40: 'rgba(255, 255, 255, 0.4)',
  white70: 'rgba(255, 255, 255, 0.7)',
  white85: 'rgba(255, 255, 255, 0.85)',
  black23: 'rgba(0, 0, 0, 0.23)',
  black65: 'rgba(0, 0, 0, 0.65)',
  chartLine: '#19D3B4',
  chartIndicatorLine: '#14D5F3',
  chartUp: '#45C8E5',
  chartDown: '#A979D8',
  tableStickyBg: '#2f304e',
  tableRowHover: 'rgba(80, 77, 255, .2)',
  skeletonBaseColor: 'rgba(80, 77, 255, .2)',
  skeletonHighlightColor: 'rgba(182, 185, 255, 0.1)',
  progressBarOthers: '#ffda79',

  collateralColors: {
    stablecoins: 'rgba(182, 139, 255, 1)',
    spark: 'rgba(234, 218, 172, 1)',
    cashRwa: 'rgba(159, 174, 255, 1)',
    legacyRwa: 'rgba(253, 112, 205, 1)',
    core: 'rgba(116, 212, 225, 1)',
    sealEngine: 'rgba(0, 204, 251, 1)',
    grove: 'rgba(39, 146, 57, 1)',
    keel: 'rgba(37, 150, 190, 1)',
    obex: 'rgb(29, 65, 87)',
    osero: 'rgba(20, 121, 155, 1)'
  }
};
